import Blazy from "blazy"
import LoadMoreHandler from "./load_more_handler.js"

export default class Page {
    constructor() {
        this.sliders = []
        this.loadMoreHandlers = []
        this.blazyInstance = null
        this.init()
    }

    async init() {
        // Esperar a que el DOM esté completamente cargado
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initializeComponents())
        } else {
            this.initializeComponents()
        }
    }

    initializeComponents() {
        this.swiper()
        this.blazy()
        this.bindLoadMoreForBlazy()
        this.initLoadMoreHandlers()
    }

    refreshScrollTriggers() {
        try {
            if (window && window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
                window.ScrollTrigger.refresh()
            }
        } catch (_) { /* noop */ }
    }

    refreshScrollTriggersDeferred() {
        // Refrescar tras el próximo frame para permitir que el layout se estabilice
        requestAnimationFrame(() => requestAnimationFrame(() => this.refreshScrollTriggers()))
    }

    initLoadMoreHandlers() {
        this.paginations = document.querySelectorAll(".section-notes-container")
        this.paginations.forEach((pagination) => {
            const handler = new LoadMoreHandler(pagination)
            this.loadMoreHandlers.push(handler)
        })
    }

    swiper() {  
        this.sliders = []
        document.querySelectorAll(".swiper.gallery").forEach((item) => {
            const slide = new Swiper(item, {
                loop: true,
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="inline-flex items-center justify-center w-8 text-sm h-8 leading-none p-2 rounded-full border border-black md:hover:scale-95 bg-white md:hover:text-white md:hover:bg-black transition-all ' + className + '">' + (index + 1) + "</span>";
                    },
                }
            })
            // Refrescar triggers al inicializar y en eventos relevantes del slider
            if (slide && typeof slide.on === 'function') {
                slide.on('init', () => {
                    this.refreshScrollTriggersDeferred()
                    this.refreshBlazyForSlider(item)
                })
                slide.on('resize', () => this.refreshScrollTriggersDeferred())
                slide.on('slideChangeTransitionEnd', () => {
                    this.refreshScrollTriggersDeferred()
                    this.refreshBlazyForSlider(item)
                })
            }
            // Refresh inicial tras crear el slider
            this.refreshScrollTriggersDeferred()
            this.sliders.push(slide)
        })
    }

    blazy() {
        // Solo usar Blazy para elementos que no tienen loading="lazy" nativo
        this.blazyInstance = new Blazy({
            selector: '.b-lazy:not([loading="lazy"])',
            offset: 100,
            success: (el) => {
                // Agregar atributos width y height inline después de la carga
                el.setAttribute('width', el.naturalWidth)
                el.setAttribute('height', el.naturalHeight)
                
                // Agregar clase b-loaded para activar las transiciones
                el.classList.add('b-loaded')
                el.parentElement.classList.add("loaded")
                
                // Trigger de evento personalizado para analytics
                el.dispatchEvent(new CustomEvent('blazy:loaded', {
                    detail: { element: el }
                }))

                // Refrescar triggers tras cambios de layout por la imagen
                this.refreshScrollTriggersDeferred()
            },
            error: (el, msg) => {
                console.warn('Blazy error:', msg)
                
                // Agregar clase de error para estilos de fallback
                el.classList.add('b-error')
                el.parentElement.classList.add("error")
                
                // Trigger de evento personalizado para analytics
                el.dispatchEvent(new CustomEvent('blazy:error', {
                    detail: { element: el, message: msg }
                }))

                // Aunque haya error, el layout puede cambiar; refrescar triggers
                this.refreshScrollTriggersDeferred()
            }
        })
        
        // Agregar event listeners para imágenes con lazy loading nativo
        this.setupNativeLazyLoading()
        
        return this.blazyInstance
    }

    refreshBlazyForSlider(sliderElement) {
        // Refrescar blazy para banners que aparecen en el slider
        if (this.blazyInstance) {
            // Buscar elementos b-lazy dentro del slider que no estén cargados
            const lazyElements = sliderElement.querySelectorAll('.b-lazy:not(.b-loaded):not(.b-error)')
            if (lazyElements.length > 0) {
                // Forzar el refresh de blazy para estos elementos
                this.blazyInstance.load(lazyElements)
            }
        }
    }

    setupNativeLazyLoading() {
        // Manejar eventos de carga para imágenes con loading="lazy" nativo
        document.addEventListener('load', (e) => {
            if (e.target.tagName === 'IMG' && e.target.hasAttribute('loading')) {
                const img = e.target
                img.classList.add('b-loaded')
                if (img.parentElement) {
                    img.parentElement.classList.add("loaded")
                }
                
                // Trigger de evento personalizado para analytics
                img.dispatchEvent(new CustomEvent('blazy:loaded', {
                    detail: { element: img }
                }))

                // Refrescar tras carga nativa de imagen lazy
                this.refreshScrollTriggersDeferred()
            }
        })

        document.addEventListener('error', (e) => {
            if (e.target.tagName === 'IMG' && e.target.hasAttribute('loading')) {
                const img = e.target
                img.classList.add('b-error')
                if (img.parentElement) {
                    img.parentElement.classList.add("error")
                }
                
                // Trigger de evento personalizado para analytics
                img.dispatchEvent(new CustomEvent('blazy:error', {
                    detail: { element: img, message: 'Native lazy loading error' }
                }))

                // También refrescar si hay error, el layout pudo cambiar
                this.refreshScrollTriggersDeferred()
            }
        })
    }

    bindLoadMoreForBlazy() {
        document.addEventListener('loadMore:inserted', () => {
            if (this.blazyInstance && typeof this.blazyInstance.revalidate === 'function') {
                this.blazyInstance.revalidate()
            }
            // Tras insertar contenido nuevo, refrescar ScrollTrigger
            this.refreshScrollTriggersDeferred()
        })
    }


}